import React from 'react';
import PropTypes from 'prop-types';
import Banner from 'zignal-landscape/lib/Banner';
import themeable from 'zignal-landscape/lib/themeable';

const ZccNotification = ({ title, type, message, onClick, styles }) => {
  return (
    <div className={styles.ZccNotification}>
      <Banner bannerStyle="inline" bannerType={type} title={title} onClick={onClick}>
        {message}
      </Banner>
    </div>
  );
};

ZccNotification.propTypes = {
  styles: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['error', 'success', 'info', 'alert']).isRequired,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default themeable(ZccNotification);
